export default "__VITE_ASSET__D1vXdb3g__"